import { IEmailPhuHuynhActions, eEmailPhuHuynhActionTypeIds } from "../../action-types/don-hang/IEmailPhuHuynhActions";
import { IEmailPhuHuynhReducer } from "../../reducer-model/don-hang/IEmailPhuHuynhReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IParentEmail } from "../../../model/respone/category/IParentEmail";

const iniState: IEmailPhuHuynhReducer = {
    status: eReducerStatusBase.is_not_initialization,
    emails: [],
    ts_hocsinh_id: undefined
};

export const emailPhuHuynhReducer = (state: IEmailPhuHuynhReducer = iniState, action: IEmailPhuHuynhActions): IEmailPhuHuynhReducer => {
    switch (action.type) {
        case eEmailPhuHuynhActionTypeIds.LOAD_START:
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
                ts_hocsinh_id: action.payload as number
            };
        case eEmailPhuHuynhActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                emails: action.payload as IParentEmail[]
            };
        case eEmailPhuHuynhActionTypeIds.LOAD_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                emails: []
            };
        default:
            return state;
    }
};
